<template>
  <VTextField
    outlined
    dense
    :label="label"
    v-currency="options"
    ref="textField"
    v-on:change="event => calcTotalCost(event)"
    @input.native="$emit('input', $ci.getValue($refs.textField.$refs.input))"
  />
</template>

<script>
export default {
  name: "VCurrencyField",
  props: {
    label: null,
    value: {
      type: Number,
      default: null,
    },
  },
  computed: {
    options() {
      return {
        locale: "en",
        currency: "GBP",
      };
    },
  },
  watch: {
    value: "setValue",
  },
  mounted() {
    this.setValue(this.value);
  },
  methods: {
    setValue(value) {
      this.$ci.setValue(this.$refs.textField.$refs.input, value);
    },
  },
};
</script>
